import { capitalize } from 'lodash';

import { useTranslation } from '#/features/localization/utils';

import Title from '#/components/common/toast/Title';
import Buy from '#/components/common/toast/Buy';
import Sell from '#/components/common/toast/Sell';

import { Fill } from '#/api/fills';
import { Market } from '#/api/markets';

interface Props {
  fill: Fill;
  market: Market;
}

export function LimitOrderFill({ fill, market }: Props) {
  const { t } = useTranslation();
  const Container = fill.side === 'BUY' ? Buy : Sell;
  const side = capitalize(t(fill.side));

  return (
    <Container>
      <Title>{t('Limit {{side}} Order Fill', { side })}</Title>
      {fill.size.toFormat()} {market.base_currency} at $ {fill.price.toFormat()}
    </Container>
  );
}
